/* MIXINS */
import permissionsMixin from '@mixins/permissionsMixin';

export default {
  mixins: [permissionsMixin],
  data() {
    return {
      tabs: [
        {
          name: 'CRM',
          id: 'crm',
          active: true,
        },
        {
          name: 'Prospects',
          id: 'prospect',
        },
      ],
    };
  },
  methods: {},
};
